import React from 'react'

export const Footer = () => {
  return (
    <footer className='footer'>
        Portafolio Johan Gomez &copy; - 2023
    </footer>
  )
}
